import Quill from "quill";

let quillFormatsReady = false;

/** Register Quill font/size attributors once (required for toolbar pickers). */
export function ensureQuillFormatsRegistered(): void {
  if (quillFormatsReady || typeof window === "undefined") return;

  const Font = Quill.import("formats/font") as {
    whitelist: string[];
  };
  Font.whitelist = ["sans-serif", "serif", "monospace"];
  Quill.register(Font, true);

  const Size = Quill.import("attributors/class/size") as {
    whitelist: string[];
  };
  Size.whitelist = ["small", "large", "huge"];
  Quill.register(Size, true);

  quillFormatsReady = true;
}
